import React from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmModal from '../../styled-base/modal/implementations/confirm-modal';
type ColumnDeleteProps = {
    onClose: () => void,
    onYes: () => void
}

export default function ColumnDeleteDialog(props: ColumnDeleteProps) {
  const { t } = useTranslation();
   
  return (
    <ConfirmModal
        acceptText={t('Yes')}
        declineText={t('Cancel')}
        title={t('Delete Column')}
        onAccept={props.onYes}
        onDecline={props.onClose}
      >
        <div>
          {t('When you delete this column, the action items will remain in the workstream but will not appear on the board in any column. The action items will be visible and manageable from the list view.')}
          </div>
          <div><b>{t('Note:')}</b> {t('you can rename the column by clicking the name.')}</div>
      </ConfirmModal>
    
  );
}